import React, { Component } from 'react'
// import MetaTags from 'react-meta-tags'
import { Link } from 'react-router-dom'
import {
    Container, Row, Col, Spinner
} from 'reactstrap'
import ProductObj from '../../utils/producto'
import './product.css'
import Share from '../../components/facebook/share'
import ButtonsCategory from '../../components/buttonsCategory';
const prod = new ProductObj()

export default class Product extends Component {
    constructor() {
        super()
        this.state = {
            product: null,
            loading: false,
            productId: ''
        }
    }

    leerProducto(id) {
        const _this = this
        prod.leerProducto(id).then(product => {
            _this.setState({
                product,
                loading: false
            })
        })
    }

    componentWillMount() {
        let product = null
        if (this.props.match) {
            product = this.props.match.params.id
            this.setState({
                product,
                loading: true,
                productId: product
            })
            if (product)
                return this.leerProducto(product)
        }

    }

    render() {
        window.scrollTo(0, 0)
        return (
            <Container fluid={true} className="espacioAbajo">
                {/* {
                    this.state.product &&
                    <MetaTags>
                        <title>{this.state.product.Descripcion}</title>
                        <meta property="fb:app_id" content="596281580879543" />
                        <meta name="description" content={this.state.product.Descripcion} />
                        <meta name="og:type" content="product" />
                        <meta property="og:title" content={this.state.product.Descripcion} />
                        <meta property="og:description" content={this.state.product.Detalle} />
                        <meta property="og:image" content={this.state.product.Img} />
                        <meta property="og:url" content={`https://chenloseguros.com/producto/${this.state.productId}`} />
                    </MetaTags>
                } */}
                <Row>
                    <Col sm={8} md={2} lg={2}>
                        <Row>
                            <ButtonsCategory />
                        </Row>
                    </Col>
                    <Col md={9}>
                        <Container>
                            {
                                this.state.loading ?
                                    <div className="spinnerProductos"><Spinner type="grow" /></div>
                                    :
                                    <React.Fragment>
                                        <Row>
                                            <Col sm={12} lg={6}>
                                                <h2>{this.state.product.Descripcion}</h2>
                                                <p>{this.state.product.Detalle}</p>
                                            </Col>
                                            <Col sm={12} lg={5} className="imgProduct">
                                                {
                                                    this.state.product.Img &&
                                                    <img src={this.state.product.Img} alt={this.state.product.Descripcion} />
                                                }
                                            </Col>

                                        </Row>
                                        <Row>
                                            <div className="ToContactContainer">
                                                <Col xs={12} className="ToContact">
                                                    <Link className="btn btn-rojo" to={`/contacto/${this.state.productId}`} >Déjenos un mensaje para contactarlo</Link>
                                                </Col>
                                                <Col xs={12} className="ToContact">
                                                    <Share url={`https://chenloseguros.com/producto/${this.state.productId}`} btnMd={true} />
                                                </Col>
                                            </div>
                                        </Row>
                                    </React.Fragment>
                            }

                        </Container>
                    </Col>
                </Row>
            </Container>
        )
    }
}